"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthApi = void 0;
class AuthApi {
    getToken() {
        const token = {
            accessToken: 'accessToken',
            expiresIn: 100000,
            refreshExpiresIn: 100000,
            refreshToken: 'refreshToken',
            tokenType: 'Bearer',
            notBeforePolicy: 0,
            sessionState: 'session-state',
            scope: ''
        };
        return Promise.resolve(token);
    }
}
exports.AuthApi = AuthApi;
//# sourceMappingURL=AuthApi.js.map